import loginImg from "assets/img/login_top.png";
import loginAdminImg from "assets/img/admin_img.jpg";
import iconImg from "assets/img/logo-sanicor-header.png";
import sideBarImg from "assets/img/sidebar-4.jpg";

var params = [];
params['baseUrl'] = 'https://panel.sanicorcatalogo.aicor.es/';
params['loginImg'] = loginImg;
params['loginAdminImg'] = loginAdminImg;
params['sideBarIcon'] = iconImg;
params['sideBarImg'] = sideBarImg;
// "purple", "blue", "green", "orange", "red" ... modificar en material-dashboard-react.js
params['sideBarColor'] = 'blue';
params['firstColor'] = '#00528a';
params['proyectName'] = 'Panel Catálogo';
params['loaderType'] = 'MutatingDots';
params['defaultTableLength'] = 10;
params['tableLengthArray'] = [10, 25, 50];

export default params;
